import { floor } from 'lodash-es';
import { DateTime } from 'luxon';
import { IBadgeColorIcon } from '../designSystem/components/badge';
import { CampaignInput, CampaignState } from '../generated/types';
import { assertUnreachable } from '../util/assertUnreachable';
import { isNonEmptyString } from '../util/string';
import { applyMarkup } from './sms';

export function finalPriceInEuros(costInMillims: number): number {
    return floor(applyMarkup(costInMillims) / 1_000, 2);
}

export function getScheduledAt(
    campaignInput: Pick<CampaignInput, 'scheduledAtDate' | 'scheduledAtTime'>
): DateTime | null {
    let scheduledAt: DateTime | null = null;

    if (campaignInput.scheduledAtDate?.isValid && isNonEmptyString(campaignInput.scheduledAtTime)) {
        scheduledAt = DateTime.fromFormat(
            `${campaignInput.scheduledAtDate.toFormat('yyyy-MM-dd')} ${
                campaignInput.scheduledAtTime
            }`,
            'yyyy-MM-dd HH:mm'
        );
    }

    return scheduledAt;
}

export function getDelay(scheduledAt: DateTime, timeZone: string) {
    return scheduledAt
        .setZone(timeZone, { keepLocalTime: true })
        .diff(DateTime.utc())
        .shiftTo('milliseconds').milliseconds;
}

export function getStateBadgeColorIcon(state: CampaignState): IBadgeColorIcon {
    switch (state) {
        case CampaignState.Draft:
            return { color: 'gray', leftIcon: 'pen-ruler' };
        case CampaignState.Done:
            return { color: 'success', leftIcon: 'check' };
        case CampaignState.InProgress:
            return { color: 'warning', leftIcon: 'hourglass-empty' };
        case CampaignState.Scheduled:
            return { color: 'primary', leftIcon: 'calendar' };
        case CampaignState.Template:
            return { color: 'purple', leftIcon: 'paper-plane' };
        default:
            return assertUnreachable(state);
    }
}
